import {Radio as BaseRadio, RadioProps} from '@material-ui/core'
import {makeStyles} from '@material-ui/core/styles'
import clsx from 'clsx'
import React from 'react'

import {theme} from '../theme'

type Props = RadioProps & {
  error?: boolean
}

const useIconClasses = makeStyles({
  icon: {
    width: 30,
    height: 30,
    border: `9px solid ${theme.palette.grey[300]}`,
    background: theme.palette.grey[300],
    borderRadius: '50%',
  },
  checked: {
    background: 'transparent',
    borderColor: theme.palette.primary.main,
  },
  error: {
    outline: `2px solid ${theme.palette.error.main}`,
  },
})

const Radio: React.FC<React.PropsWithChildren<Props>> = ({error, ...props}) => {
  const iconClasses = useIconClasses()

  return (
    <BaseRadio
      {...props}
      checkedIcon={<span className={clsx(iconClasses.icon, iconClasses.checked)} />}
      icon={<span className={clsx(iconClasses.icon, error && iconClasses.error)} />}
    />
  )
}

export default Radio
